import { Link, Route, Routes, useLocation } from 'react-router';
import { Dock } from './components/Dock';
import { RequireLogin } from './components/RequireLogin';
import { AdminPage } from './pages/AdminPage';
import { LearnPage } from './pages/LearnPage';
import { LibraryPage } from './pages/LibraryPage';
import { ListenPage } from './pages/ListenPage';
import { MePage } from './pages/MePage';
import { ReviewPage } from './pages/ReviewPage';
import { VocabPage } from './pages/VocabPage';

export function App() {
  const { pathname } = useLocation();
  // The learn page draws its own header and dock (with this episode's steps).
  if (pathname === '/') return <LearnPage />;
  // 精听 is a full-screen page of its own (no dock), it is where learners spend the most time.
  if (pathname.startsWith('/listen/'))
    return (
      <Routes>
        <Route path="/listen/:id" element={<ListenPage />} />
      </Routes>
    );
  return (
    <div className="app">
      <header className="page-header">
        <Link className="brand" to="/">
          ENGPOD
        </Link>
      </header>
      <main>
        <Routes>
          <Route path="/vocab" element={<RequireLogin icon="bookmark" title="生词本"><VocabPage /></RequireLogin>} />
          <Route path="/review" element={<RequireLogin icon="clipboard" title="复习"><ReviewPage /></RequireLogin>} />
          <Route path="/library" element={<RequireLogin icon="library" title="资料库"><LibraryPage /></RequireLogin>} />
          <Route path="/me" element={<MePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/:id" element={<AdminPage />} />
          <Route path="*" element={<p className="page">页面不存在</p>} />
        </Routes>
      </main>
      <Dock />
    </div>
  );
}
